import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import { alertState } from "src/recoil/atoms/global";
import { usePatchedNavigate } from "src/Hooks/usePatchedNavigate";
import { useMutation } from "src/Hooks/useReactQuery";
import { createTestPackage } from "src/services/test-packages";
import APP_ROUTES from "src/routes/routes";

const useCreateTestPackage = () => {
  const { t } = useTranslation("test-package");
  const navigate = usePatchedNavigate();
  const showAlert = useSetRecoilState(alertState);

  const createTestPackageMutation = useMutation({
    mutationFn: ({ data }) => createTestPackage({ data }),
  });

  const submitData = ({ data }, callback) => {
    createTestPackageMutation.mutate(
      { data },
      {
        onSuccess: () => {
          showAlert({
            status: true,
            message: t("new.create_success"),
            type: "success",
          });
          navigate(APP_ROUTES.TEST_PACKAGE);
        },
        onError: () => {
          const isSubmitFailed = true;
          callback?.(isSubmitFailed);
        },
        onSettled: () => {
          const isSubmitFailed = false;
          callback?.(isSubmitFailed);
        },
      }
    );
  };

  return {
    createTestPackageMutation,
    submitData,
    isLoading: createTestPackageMutation.isLoading,
    isError: createTestPackageMutation.isError,
    error: createTestPackageMutation.error,
  };
};

export default useCreateTestPackage;
